import AuditLogsApp from "./AuditLogsApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(AuditLogsApp);
